import React from 'react';
import { ShieldCheck, Truck, Sparkles } from 'lucide-react';
import { containerWide } from '../styles/ui';

const Hero = () => {
  return (
    <section id="home" className="hero-gradient pt-32 sm:pt-36 pb-20 sm:pb-28 overflow-hidden relative">
      <div
        className="absolute -top-24 -right-24 w-[28rem] h-[28rem] bg-emerald-200/30 rounded-full blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <div
        className="absolute -bottom-32 -left-16 w-[24rem] h-[24rem] bg-accent-200/30 rounded-full blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <div
        className="absolute top-1/3 left-1/2 w-[20rem] h-[20rem] bg-highlight-200/20 rounded-full blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <div className={`${containerWide} relative`}>
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left animate-fade-in">
            <span className="inline-flex items-center gap-2 bg-white/80 border border-emerald-100 text-emerald-700 text-xs font-semibold tracking-wide uppercase px-4 py-2 rounded-full shadow-soft mb-6">
              <Sparkles size={14} className="text-accent-500" aria-hidden="true" />
              Fresh, Hygienic &amp; Handpicked Daily
            </span>
            <h1 className="serif text-5xl md:text-7xl text-emerald-950 leading-[1.05] mb-6 font-bold">
              Fresh Meat. Quality Groceries.<br />
              <span className="bg-gradient-primary bg-clip-text text-transparent">Delivered to Your Door.</span>
            </h1>
            <p className="text-lg text-ink-secondary mb-10 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Fresh products, hygienically handled and delivered quickly. Premium cuts of meat, poultry, and seafood — expertly cleaned, hygienically packed, and bursting with freshness in every order.
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-8">
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-800 bg-emerald-50 border border-emerald-100 px-3 py-1.5 rounded-full">
                <ShieldCheck size={14} aria-hidden="true" /> Hygienically Packed
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-700 bg-accent-50 border border-accent-100 px-3 py-1.5 rounded-full">
                <Truck size={14} aria-hidden="true" /> Same-Day Delivery
              </span>
            </div>
            <div className="flex justify-center lg:justify-start">
              <a
                href="#categories"
                className="btn-glow inline-flex items-center gap-2 bg-gradient-primary text-white font-semibold px-8 py-3.5 rounded-full shadow-glow-teal transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700 focus-visible:ring-offset-2"
              >
                Shop Now
              </a>
            </div>
          </div>
          <div className="flex-1 relative animate-fade-in delay-1">
            <div className="absolute -inset-4 bg-gradient-to-br from-emerald-200/40 to-accent-200/30 rounded-[2.5rem] blur-2xl" aria-hidden="true" />
            <div className="relative z-10 rounded-[2rem] overflow-hidden shadow-floating ring-1 ring-black/5 transition-all duration-500">
              <img
                src="/hero-image.jpg.jpg"
                alt="Fresh Meat and Seafood"
                className="w-full h-[320px] sm:h-[420px] lg:h-[600px] object-cover"
              />
            </div>

            {/* Floating trust cards — layered over the hero image for depth */}
            <div className="hidden sm:flex absolute -left-8 top-10 z-20 glass-card rounded-2xl shadow-glass px-4 py-3 items-center gap-3 animate-fade-in delay-2">
              <div className="w-10 h-10 rounded-xl bg-success-500/15 flex items-center justify-center shrink-0">
                <ShieldCheck size={20} className="text-success-600" aria-hidden="true" />
              </div>
              <div>
                <p className="text-sm font-bold text-emerald-950 leading-tight">100% Hygienic</p>
                <p className="text-xs text-ink-secondary leading-tight">Quality checked daily</p>
              </div>
            </div>

            <div className="hidden sm:flex absolute -right-6 bottom-12 z-20 glass-card rounded-2xl shadow-glass px-4 py-3 items-center gap-3 animate-fade-in delay-2">
              <div className="w-10 h-10 rounded-xl bg-accent-500/15 flex items-center justify-center shrink-0">
                <Truck size={20} className="text-accent-600" aria-hidden="true" />
              </div>
              <div>
                <p className="text-sm font-bold text-emerald-950 leading-tight">Fast Delivery</p>
                <p className="text-xs text-ink-secondary leading-tight">Fresh to your door</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
